import { render, staticRenderFns } from "./mnewsinfo.vue?vue&type=template&id=76f7d2c1&scoped=true"
import script from "./mnewsinfo.vue?vue&type=script&lang=js"
export * from "./mnewsinfo.vue?vue&type=script&lang=js"
import style0 from "./mnewsinfo.vue?vue&type=style&index=0&id=76f7d2c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__lodash_sniwsisxdvcgzet3yrvlfqnueq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f7d2c1",
  null
  
)

export default component.exports